module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8705/img/spinner.png"